import { Container, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import LocationCreateOrEditForm from './components/LocationCreateOrEditForm';

const LocationEditPage = () => {
    const history = useHistory();
    const { locationId } = useParams();
    const { notifySuccess } = useNotify();
    const [stripeError, setStripeError] = useState(false);
    const [location, ,] = useSwaggerClient('terminals', 'getTerminalLocation', {
        locationId
    });
    const [submitLocation, setSubmitLocation] = useState(false);

    const onSubmit = (values, { setSubmitting }) => {
        doSwaggerCall('terminals', 'updateTerminalLocation', {
            locationId,
            locationData: {
                display_name: values.display_name,
                address: {
                    country: values.country,
                    postal_code: values.postal_code,
                    state: values.state,
                    city: values.city,
                    line1: values.line1,
                    line2: values.line2
                }
            }
        })
            .then(() => {
                notifySuccess('Successfully updated location');
                setStripeError(false);
                setSubmitLocation(true);
            })
            .catch(err => {
                setStripeError(`${err.code} - ${err.message}`);
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <Container fixed className="activity-edit page">
            <Grid item container xs={12} spacing={2}>
                <Typography variant="h2">Edit location</Typography>
                <LocationCreateOrEditForm
                    initialValues={location}
                    locationId={locationId}
                    onSubmit={onSubmit}
                    stripeError={stripeError}
                    onBack={() => history.goBack()}
                    submitLocation={submitLocation}
                />
            </Grid>
        </Container>
    );
};

export default LocationEditPage;
